import { APP_PERMISSIONS } from '@exam-center/permission';
import { Navigate } from '@exam-center/router';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

export default function AdminExamLocationManagementPage() {
  const { permissions } = usePermission();

  // TODO: update initial tab with audit log permission
  const initialTab = useMemo(() => {
    if (
      permissions.some((permission) =>
        [
          APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW,
          APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_USAGE.VIEW,
        ].includes(permission),
      )
    ) {
      return 'locations';
    }
    if (
      permissions.some((permission) =>
        [
          APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW,
          APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST_FIRST_TIER_REVIEW
            .VIEW,
          APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST_SECOND_TIER_REVIEW
            .VIEW,
        ].includes(permission),
      )
    ) {
      return 'requests';
    }
    if (
      permissions.some((permission) =>
        [APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.AUDIT_LOG.VIEW].includes(permission),
      )
    ) {
      return 'activity-log';
    }
    return 'cancellations';
  }, [permissions]);

  return <Navigate to={`/admin/exam-location/${initialTab}`} replace />;
}
